import { Stack } from "@mui/material";
import React from "react";
import PetSelector from "../../../../../components/form/PetSelector";
import { UserSelectorView } from "../../../../../components/modals/bookingModalComponents/components/AdminBooking";
import BookingModalContext, {
  BookingContext,
} from "../../../../../components/modals/bookingModalComponents/context/BookingModalContext";
import UserProvider from "../../../../../contexts/UserProvider";
import { PETS_FOR_BOXES_DROP_DOWN } from "../../../../../enums/QueryKeys";

export default function BoxPetSelector({
  pets = [],
  noNewPets = false,
  queryKey = PETS_FOR_BOXES_DROP_DOWN,
  url = "/saps/box/get/available/pets",
  showUserSelector = false,
}) {
  if (showUserSelector) {
    return (
      <BookingModalContext>
        <Content
          pets={pets}
          noNewPets={noNewPets}
          queryKey={queryKey}
          url={url}
          showUserSelector={showUserSelector}
        />
      </BookingModalContext>
    );
  } else {
    if (pets?.length > 0) {
      return (
        <PetSelector
          shouldFilter={false}
          noNewPets={noNewPets}
          queryKey={queryKey}
          url={url}
          petsListProp={pets}
        />
      );
    }
    return (
      <PetSelector
        noNewPets={noNewPets}
        queryKey={queryKey}
        url={url}
        shouldFilter={false}
      />
    );
  }
}

function Content({ pets, noNewPets, queryKey, url, showUserSelector }) {
  const data = React.useContext(BookingContext);

  if (pets.length > 0) {
    return (
      <Wrapper userSelectorData={data} showUserSelector={showUserSelector}>
        <PetSelector
          isNewUserSelected={data.isNewUserSelected()}
          noNewPets={noNewPets}
          queryKey={queryKey}
          url={url}
          petsListProp={pets}
        />
      </Wrapper>
    );
  }
  return (
    <Wrapper userSelectorData={data} showUserSelector={showUserSelector}>
      <PetSelector
        noNewPets={noNewPets}
        queryKey={queryKey}
        url={url}
        isNewUserSelected={data.isNewUserSelected()}
      />
    </Wrapper>
  );
}

function Wrapper({ children, userSelectorData, showUserSelector }) {
  return (
    <UserProvider>
      {showUserSelector && (
        <Stack>
          <UserSelectorView data={userSelectorData} showNewUserForm={true} />
        </Stack>
      )}
      {children}
    </UserProvider>
  );
}
